import { atom } from "recoil";
import { IBadgeData, useXoraiaValue } from "./useXoraia";
import useSWR from "swr";

export const USE_BADGES = atom<IBadgeData[]>({
  key: "USE_BADGES",
  default: [],
});

export const useBadges = (articleId?: string) => {
  const { apiFetcher, businessId } = useXoraiaValue();
  const requestKey = `useBadges${articleId ? "-" + articleId : ""}`;

  const { data } = useSWR(
    requestKey,
    async () => {
      try {
        if (!apiFetcher || !apiFetcher.badges) {
          throw "no-api-fetcher";
        }

        const _opts = await apiFetcher.badges({ businessId, articleId });

        return _opts ?? [];
      } catch (error) {
        console.error("useBadges/Error =>", error);

        return [];
      }
    },
    { fallbackData: [] }
  );

  console.log("useBadges/Data =>", data);

  return { badges: data };
  // const { apiFetcher, businessId } = useXoraiaValue();
  // const [badges, setBadges] = useRecoilState(USE_BADGES);

  // React.useEffect(() => {
  //   const getBadges = async () => {
  //     if (!apiFetcher || !apiFetcher.badges || badges.length !== 0) return;

  //     try {
  //       const _opts = await apiFetcher.badges({ businessId });

  //       if (_opts.length > 0) setBadges(_opts);
  //     } catch (error) {
  //       console.error("GET BADGE =>", error);
  //     }
  //   };

  //   getBadges();
  // }, [apiFetcher, badges]);

  // return { badges, setBadges };
};
